import React, { Component } from "react";

export default class Dean extends Component {
  render() {
    return (
<>
          <h1>It's..... Dean Sumitro!</h1>
            <h1>
              Tab Hoarder | Forgetful Web Surfer | Impulsive youtube binger
            </h1>
            <ul>
              <li>
                I enjoy looking at how things are functionally and aesthetically
                designed, both in a physical and virtual space, and finding ways
                to improve them.
              </li>
              <li>
                Outside of work, I play all the video games, I do urban-style
                dancing, listen to music all the time, and occasionally imagine
                what it would be like to have a Shiba Inu.
              </li>
              <li>
                I love traveling ever since I was a kid. Currently my bucketlist
                has cities and places such as: Singapore, Japan, Germany, South
                Korea, Hong Kong & Taiwan.
              </li>
              <li>Quirk: Dean is a snacking fiend, but we still love them.</li>

              <img src="/img/dean1.svg" alt="" />
              <img src="/img/dean2.svg" alt="" />
              <img src="/img/dean3.svg" alt="" />
              <img src="/img/dean4.svg" alt="" />
            </ul>
</>
    );
  }
}
